import { CLEAR_ERRORS } from './ActionTypes';
export function clearErrors() {
  return dispatch => {
    dispatch({
      type: CLEAR_ERRORS
    });
  };
}